export const GET_TRUCK_ROUTE_SCHEDULE_LIST = 'GET_TRUCK_ROUTE_SCHEDULE_LIST';
export const GET_TRUCK_ROUTE_SCHEDULE_LIST_LOADING =
  'GET_TRUCK_ROUTE_SCHEDULE_LIST_LOADING';
export const GET_TRUCK_ROUTE_SCHEDULE_LIST_LOADING_ERROR =
  'GET_TRUCK_ROUTE_SCHEDULE_LIST_LOADING_ERROR';
export const CLEAR_TRUCK_ROUTE_SCHEDULE_LIST_ERROR =
  'CLEAR_TRUCK_ROUTE_SCHEDULE_LIST_ERROR';
export const DELETE_TRUCK_ROUTE_SCHEDULE_LOADING =
  'DELETE_TRUCK_ROUTE_SCHEDULE_LOADING';
export const DELETE_TRUCK_ROUTE_SCHEDULE = 'DELETE_TRUCK_ROUTE_SCHEDULE';
export const DELETE_TRUCK_ROUTE_SCHEDULE_ERROR =
  'DELETE_TRUCK_ROUTE_SCHEDULE_ERROR';
export const CLEAR_DELETE_TRUCK_ROUTE_SCHEDULE_SUCCESS =
  'CLEAR_DELETE_TRUCK_ROUTE_SCHEDULE_SUCCESS';



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/managetruckrouteschedulelist/types.js